const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Service Areas',
    description:
      'When a homeowner searches for Enphase installers in a particular area, we will use the %{regionOrCountyLabel} entered by you here to check if you are available for service in that area or not.',
    addNewArea: 'Add New Area',
    new: 'New',
    areaName: 'Area Name',
    servicesCovered: {
      countiesCovered: 'Counties Covered',
      regionsCovered: 'Regions Covered',
      provincesCovered: 'Provinces Covered',
      regionsWithCount: '%{region}(first %{typeCharacters} digits of postcodes) Covered',
      districtsCovered: 'Districts Covered',
      citiesCovered: 'Municipalities Covered',
      citiesCoveredbr: 'Cities Covered',
      departments: 'departments',
      regions: 'regions',
      counties: 'counties',
      districts: 'districs',
      cities: 'municipalities',
      provinces: 'provinces',
      city: 'cities'
    },
    selectAllCounty: 'Select all %{regionOrCountyLabel} From a Specific State',
    selectAllCountyWithRegion: 'Select all %{regionOrCountyLabel} From a Specific Region',
    selectAllDepartment: 'Select all departments',
    addCountiesRegionsButton: 'Add %{regionOrCountyLabel}',
    countyButtonDescription: 'Based on your State selection, all related %{regionOrCountyLabel} will be added',
    countyButtonDescriptionWithRegion: 'Based on your Region selection, all related %{regionOrCountyLabel} will be added',
    area1: 'AREA 1',
    selectState: 'Select State',
    selectRegion: 'Select Region',
    requestNotProcessed: 'Request could not be processed',
    footerTitle:
      'Indicative pricing should be inclusive of costs for installation, racking, PV module, inverter, etc. Costs such as roofing, main panel upgrade may be additional',
    footerBody:
      'Enphase will provide this indicative pricing to the homeowner. Enphase will provide a disclaimer to the Homeowner that this pricing is preliminary and subject to change.​',
    noBlankRegions: `%{regionOrCountyLabel} covered can't be blank`,
    //noBlankCounties: `Counties covered can't be blank`,
    deleteConfirmation: 'Are you sure you want to delete this service area ?',
    ok: 'Ok',
    infoText: `%{bTagOpen}Region%{bTagClose} is defined as the first %{count} digits of a postal code in a %{stateOrProvince}`,
    infoTextFr: `Department is defined as first 2 digits for postcode`,
    state: 'state',
    province: 'province',
    noOptions: 'No Options'
  }
};

export default serviceAreas;
